import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Icons for navigation
import { ReactComponent as UsersIcon } from '../assets/icons/users.svg';
import { ReactComponent as ChannelsIcon } from '../assets/icons/channels.svg';
import { ReactComponent as PortalUsersIcon } from '../assets/icons/portal-users.svg';
import { ReactComponent as LogoutIcon } from '../assets/icons/logout.svg';

const Sidebar = () => {
  const { userRole, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="w-64 h-screen bg-primary-700 text-white flex flex-col">
      <div className="p-4">
        <img src="/logo.png" alt="Satori Logo" className="h-10 w-auto" />
      </div>
      
      <div className="border-b border-primary-600 mx-4 my-2"></div>
      
      <nav className="flex flex-col gap-2 p-4 flex-grow">
        <NavLink 
          to="/users" 
          className={({ isActive }) => 
            `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
              isActive 
                ? 'bg-primary-600 text-white' 
                : 'text-white/80 hover:bg-primary-600 hover:text-white'
            }`
          }
        >
          <UsersIcon className="w-5 h-5" />
          <span>Manage Users</span>
        </NavLink>
        
        <NavLink 
          to="/channels" 
          className={({ isActive }) => 
            `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
              isActive 
                ? 'bg-primary-600 text-white' 
                : 'text-white/80 hover:bg-primary-600 hover:text-white'
            }`
          }
        >
          <ChannelsIcon className="w-5 h-5" />
          <span>Manage Channels</span>
        </NavLink>
        
        {/* Show Portal Users only for admin role */}
        {userRole === 'admin' && (
          <NavLink 
            to="/portal-users" 
            className={({ isActive }) => 
              `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                isActive 
                  ? 'bg-primary-600 text-white' 
                  : 'text-white/80 hover:bg-primary-600 hover:text-white'
              }`
            }
          >
            <PortalUsersIcon className="w-5 h-5" />
            <span>Manage Portal Users</span>
          </NavLink>
        )}
      </nav>
      
      <div className="border-t border-primary-600 mx-4 my-2"></div>
      
      <div className="p-4">
        <button 
          onClick={handleLogout}
          className="flex items-center gap-3 text-white/80 hover:text-white w-full px-4 py-3 rounded-lg hover:bg-primary-600 transition-colors"
        >
          <LogoutIcon className="w-5 h-5" />
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;